export default function UsernameMsgBox({ onClose }) {
  return (
    <>
      <div className="customize-username-msg-box">
        <div className="customize-username-msg-box-container">
          <p>Successfully changed</p>
        </div>
      </div>
    </>
  )
}
